import { Maybe, Strapi_NavbarLinkRelationResponseCollection } from '@types'

const getNavItemUrl = (navbarLinks?: Maybe<Strapi_NavbarLinkRelationResponseCollection> | undefined) => {
  if (navbarLinks?.data.length === 0) {
    return ''
  }
  return navbarLinks?.data[0].attributes?.url || ''
}

export default getNavItemUrl
